<template>
  <div class="md-layout-item md-size-100 md-layout">
    <div
      class="
        md-layout-item md-size-100 md-small-size-100 md-layout
        h-28
        items-center
        mt-[16px]
        border-2 border-dashed border-rgba(102,
        102, 102,
        0.4)
        bg-gray-50
      "
    >
      <div class="md-layout-item md-size-20 pt-[6px] p-0">
        <md-checkbox :value="value" v-model="resSetting" :disabled="disabled">{{
          $t(label)
        }}</md-checkbox>
      </div>
      <div
        class="md-layout-item md-size-30 mt-2 -mb-2"
        v-if="resSetting && resSetting !== 'other_staffs' && !isRoleTeacher"
      >
        <md-field>
          <label>{{ $t("communication.filter_by") }}</label>
          <md-select v-model="respondentFilter.filter" :disabled="disabled">
            <md-option
              v-for="option in filterList"
              :value="option.id"
              :key="option.id + option.name"
              >{{ $t(option.name) }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30" v-if="multiRespondent">
        <validation-field
          :validations="{ required: true }"
          :name="nameResRequire"
          type="multi-select"
          style="margin-bottom: 0px !important"
          :key="resComponentKey"
        >
          <template #default="{ errors }">
            <CheckboxMultiSelect
              :label="labelRes"
              :options="optionResSelected"
              :trackBy="trackByRes"
              v-model="respondentFilter.filter_id"
              :isDisabled="disabled"
              @filtering="filteringOpts($event.text)"
              @select="selectItem"
              @open="openOpts"
              @removed="removedItem"
            >
            </CheckboxMultiSelect>
            <span class="md-error">{{ errors[0] }}</span>
          </template>
        </validation-field>
      </div>
      <div
        class="md-layout-item md-size-20 pt-[6px] pr-0"
        v-if="statusRespondent"
      >
        <md-checkbox v-model="respondentFilter.status" :disabled="disabled">{{
          $t("survey.active_status")
        }}</md-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import cloneDeep from "lodash/cloneDeep";
import { dataOts } from "./Respondent.js";
import { LIST_RESPONDENT } from "./index.js";
import { service_paths } from "@/constants/Services";
import { debounce } from "@syncfusion/ej2-base";

const resSettingDefault = () => ({
  filter: "all",
  filter_id: [],
  status: false
});

export default {
  props: [
    "label",
    "value",
    "filterList",
    "roleId",
    "respondentFilterProps",
    "settingProps",
    "isSettingEdit",
    "disabled",
    "isRoleTeacher",
    "listOptions"
  ],
  components: { CheckboxMultiSelect },
  mixins: [dataOts],
  data() {
    return {
      key: null,
      nameResRequire: null,
      resComponentKey: null,
      labelRes: null,
      trackByRes: null,
      optionResSelected: [],
      resSetting: null,
      respondentFilter: resSettingDefault()
    };
  },
  created() {
    if (this.respondentFilterProps) {
      this.respondentFilter = cloneDeep(this.respondentFilterProps);
      if (this.isSettingEdit) {
        this.getOptionEdit();
      } else {
        this.optionResSelected = this.listOptions;
        this.getOptionSelected();
      }
      this.defaultVal = cloneDeep(this.respondentFilter);
      this.resSetting = this.settingProps;
    }
  },
  watch: {
    resSetting: async function(resSetting) {
      this.$emit("checkRespondent", resSetting);
      if (resSetting !== "other_staffs" && resSetting === null) {
        this.respondentFilter = resSettingDefault();
        if (this.respondentFilterProps)
          this.respondentFilterProps.filter_id = [];
      }
      if (resSetting === "other_staffs") {
        this.resComponentKey++;
        this.labelRes = "sidebar.role";
        this.nameResRequire = `role of ${this.resSetting}`;
        if (!this.respondentFilter.filter_id.length) {
          await this.debounceSearchKey(
            event,
            { "name__~": "", limit: 20 },
            `${service_paths.staffs}/roles`
          );
          this.respondentFilter.filter_id = this.optionResSelected.map(
            item => item.id
          );
        }
      }
      if (this.isRoleTeacher) {
        this.respondentFilter.filter = "class";
      }
    },
    "respondentFilter.filter": function(filter, oldvalue) {
      this.selectRespondent(filter);
    }
  },
  computed: {
    statusRespondent() {
      return (
        this.resSetting &&
        this.respondentFilter.filter !== "student" &&
        this.respondentFilter.filter !== "family" &&
        this.respondentFilter.filter !== "teacher"
      );
    },
    multiRespondent() {
      return (
        (this.resSetting && this.respondentFilter.filter !== "all") ||
        this.resSetting === "other_staffs"
      );
    }
  },
  methods: {
    openOpts(event) {
      this.fetchSurvey(event);
    },
    selectItem(event) {
      if (this.resSetting !== "other_staffs")
        this.optionSelected[LIST_RESPONDENT[this.respondentFilter.filter]].push(
          event.itemData
        );
    },
    removedItem(event) {
      if (this.resSetting !== "other_staffs")
        this.optionSelected[
          LIST_RESPONDENT[this.respondentFilter.filter]
        ] = this.optionSelected[
          LIST_RESPONDENT[this.respondentFilter.filter]
        ].filter(item => {
          return this.respondentFilter.filter === "grade"
            ? item.name !== event.itemData?.name
            : item.id !== event.itemData?.id;
        });
    },
    filteringOpts: debounce(function(event) {
      this.fetchSurvey(event);
    }, 400),
    getOptionSelected() {
      this.optionSelected[
        LIST_RESPONDENT[this.respondentFilter.filter]
      ] = this.optionResSelected.filter(option => {
        return this.respondentFilter.filter_id
          .map(item => item)
          .includes(option.id);
      });
    },
    getOptionEdit() {
      this.optionSelected[
        LIST_RESPONDENT[this.respondentFilter.filter]
      ] = this.listOptions;
      this.checkDataEdit();
    },
    async checkDataEdit() {
      if (this.respondentFilter.filter) {
        await this.fetchSurvey();
        if (this.value === "other_staffs") {
          this.resSetting = this.value;
          await this.debounceSearchKey(
            event,
            { "name__~": "", limit: 20 },
            `${service_paths.staffs}/roles`
          );
          this.respondentFilter.filter_id = this.respondentFilterProps.filter_id;
        }
        this.resSetting = this.value;
      }
    },
    selectRespondent(respondented) {
      let filterSelected = this.defaultVal?.filter;
      if (
        filterSelected !== respondented &&
        this.resSetting !== "other_staffs"
      ) {
        this.respondentFilter.filter_id = [];
        this.optionResSelected = [];
        this.defaultVal = null;
      }
      this.resComponentKey++;
      this.trackByRes = "id";
      switch (respondented) {
        case "class":
          this.labelRes = "common.class";
          this.nameResRequire = `class of ${this.resSetting}`;
          break;
        case "term":
          this.labelRes = "common.term";
          this.nameResRequire = `term of ${this.resSetting}`;
          break;
        case "grade":
          this.labelRes = "common.grade";
          this.nameResRequire = `grade of ${this.resSetting}`;
          this.trackByRes = "name";
          break;
        case "program":
          this.labelRes = "common.program";
          this.nameResRequire = `program of ${this.resSetting}`;
          break;
        case "student":
          this.labelRes = "common.student";
          this.nameResRequire = `student name - student ID of ${this.resSetting}`;
          break;
        case "family":
          this.labelRes = "survey.parent_info";
          this.nameResRequire = `parent name - parent username of ${this.resSetting}`;
          break;
        case "teacher":
          this.labelRes = "survey.teacher_info";
          this.nameResRequire = `teacher name - staff ID of ${this.resSetting}`;
          break;
        case "all":
          this.respondentFilter.filter_id = [];
          break;
        default:
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-checkbox {
  display: flex;
}
.md-checkbox {
  width: 300px;
}
.checkbox-name {
  color: gray;
  font-size: 16px;
  width: 170px;
}
.md-input {
  width: 220px;
}
.from-submit {
  display: flex;
  justify-content: center;
}
.md-error {
  position: absolute;
  color: var(--md-theme-default-fieldvariant, #ff1744);
  font-size: 12px;
}
.md-title {
  font-size: 18px;
}
.hidden-tooltip {
  display: none;
}
.md-tooltip {
  overflow-wrap: break-word;
}
.required:after {
  content: " *";
  color: red;
}
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
::v-deep .md-checkbox.md-disabled .md-checkbox-label,
.md-checkbox.md-disabled .md-checkbox-container {
  opacity: 4.26;
  border-color: rgba(0, 0, 0, 0.54) !important;
  cursor: not-allowed;
}
</style>
